import axios from "axios";
import config from "../config/config";
import { getHeaders } from "./apiHelper";

const API_URL = config.API_URL; 

export const getConsequence = async () => {
  const response = await axios.get(`${API_URL}consequence`, { headers: getHeaders() });
  return response.data;
};

export const storeConsequence = async (squad) => {
  const isMultipart = typeof FormData !== 'undefined' && squad instanceof FormData;
  const response = await axios.post(`${API_URL}consequence`, squad, { headers: getHeaders(isMultipart) });
  return response.data;
};

export const getDetailConsequence = async (id) => {
  const response = await axios.get(`${API_URL}consequence/${id}`, { headers: getHeaders() });
  return response.data;
};

export const deleteConsequence = async (id) => {
  const response = await axios.delete(`${API_URL}consequence/${id}`, { headers: getHeaders() });
  return response.data;
};

export const updateConsequence = async (id, data) => {
  const isMultipart = typeof FormData !== 'undefined' && data instanceof FormData;
  if (isMultipart) {
    if (!data.has('_method')) {
      data.append('_method', 'PUT');
    }
    const response = await axios.post(`${API_URL}consequence/${id}`, data, { headers: getHeaders(true) });
    return response.data;
  }
  const response = await axios.put(`${API_URL}consequence/${id}`, data, { headers: getHeaders(false) });
  return response.data;
};
